import { Info } from "@mui/icons-material";

export const URLS = {
  AUTH: {
    ID_VALIDATE: (userId: string) => `/api/auth/id/validate?userId=${userId}`,
    NICK_NAME_VALIDATE: (nickName: string) => `/api/auth/nickname/validate?nickname=${nickName}`,
    EMAIL_VALIDATE: (email: string) => `/api/auth/emails/${encodeURIComponent(email)}/validate`,
    SIGNUP:`/api/auth/users/signup`,
    CLINICS_SIGNUP:`/api/auth/clinics/signup`,
    PASSWORD_VERIFY: `/api/auth/password/verify`,
    PASSWORD_RESET: `/api/auth/password/reset`,
    // 이메일 6자리 코드 방식 (신규)
    PASSWORD_RESET_REQUEST: `/api/auth/password-reset/request`,
    PASSWORD_RESET_VERIFY: `/api/auth/password-reset/verify`,
    PASSWORD_RESET_CONFIRM: `/api/auth/password-reset/confirm`,
    NAVER_LOGIN: `/api/auth/social/naver/login`,
    NAVER_RESTORE: `/api/auth/social/naver/restore`,
    KAKAO_LOGIN: `/api/auth/social/kakao/login`,
    KAKAO_RESTORE: `/api/auth/social/kakao/restore`,
    APPLE_LOGIN: `/api/auth/social/apple/login`,
    APPLE_RESTORE: `/api/auth/social/apple/restore`,
    // 탈퇴 후 30일 유예 기간 내 계정 복구 (인증 우회)
    RESTORE: `/api/auth/restore`,
    // 회원가입 이메일 인증 (공개)
    EMAIL_VERIFICATION_SEND: `/api/auth/email/verification/send`,
    EMAIL_VERIFICATION_VERIFY: `/api/auth/email/verification/verify`,
  },

  SEARCH:{
    HOME: '/api/home',
    HOME_SUMMARY: '/api/home/summary',
    HOME_RECRUITMENTS: '/api/home/recruitments',
    HOME_EXPERT_LOUNGE: '/api/home/expert-lounge',
    SUBWAY_STATIONS:(lineId:string) => `/api/search/subway-lines/${lineId}/stations`,
    SUBWAY_LINES:(areaId:string) => `/api/search/subway-lines?areaId=${areaId}`,
    SUBWAY_AREA: `/api/search/subway-area`,
    // 전국 역 이름 검색 — ?q=서면&limit=30 → [{id, name, lineNo}]
    SUBWAY_STATION_SEARCH: `/api/search/subway-stations`,
    RECRUITMENT_META: `/api/recruitments/search/meta`,
    GET_CITIES:`/api/search/cities`,
    GET_DISTRICTS:(cityId: string) => `/api/search/cities/${cityId}/districts`,
    GET_DISTRICTS_BATCH: `/api/search/districts`,
    RESUME_META:`/api/resume/meta`
  },

  SIGNUP: {
      USERS_META: '/api/auth/users/signup/meta',
      CLINICS_META: '/api/auth/clinics/signup/meta',
  },

  USER:{
    LOGIN: '/api/auth/users/login',
    REFRESH: '/api/auth/users/refresh',
    LOGOUT: '/api/users/logout',
    ME: '/api/users/profile',
    ME_SUMMARY: '/api/users/me/summary',
    UPDATE_PROFILE: '/api/users/profile',
    AGREEMENTS: '/api/users/me/agreements',
    PUSH_AGREEMENTS: '/api/users/me/push-agreements',
    SAVED_FILTERS: '/api/users/me/saved-filters',
    SAVED_FILTER: (domain: 'recruitment' | 'seminar') => `/api/users/me/saved-filters/${domain}`,
    DEVICES: '/api/users/me/devices',
    DEVICE: (token: string) => `/api/users/me/devices/${encodeURIComponent(token)}`,
    PUSH_OPENS: '/api/users/me/push-opens',
    NOTIFICATIONS: '/api/users/me/notifications',
    NOTIFICATIONS_UNREAD_COUNT: '/api/users/me/notifications/unread-count',
    NOTIFICATION_READ: (id: string) => `/api/users/me/notifications/${encodeURIComponent(id)}/read`,
    NOTIFICATIONS_READ_ALL: '/api/users/me/notifications/read-all',
    CHANGE_PASSWORD: '/api/users/me/password',
    WITHDRAW: '/api/users/me/withdraw',
    LICENSE_VERIFICATION: '/api/users/me/license-verification',
  },

  POST: {
    CREATE:`/api/posts`,
    WRITE_LIMIT:`/api/posts/write-limit`,
    ALIAS: `/api/posts/alias`,
    VIEW_POST:(postId:string) => `/api/posts/${postId}`,
    GET_POST:(postId:string) => `/api/posts/${postId}`,
    UPDATE_POST:(postId:string) => `/api/posts/${postId}`,
    DELETE_POST:(postId:string) => `/api/posts/${postId}`,
    CREATE_COMMENT:(postId:string) => `/api/posts/${postId}/comments`,
    UPDATE_COMMENT:(postId:string, commentId:string) => `/api/posts/${postId}/comments/${commentId}`,
    DELETE_COMMENT:(postId:string, commentId:string) => `/api/posts/${postId}/comments/${commentId}`,
    CREATE_REPLY:(postId:string, commentId:string) => `/api/posts/${postId}/comments/${commentId}/replies`,
    UPDATE_REPLY:(postId:string, commentId:string, replyId:string) => `/api/posts/${postId}/comments/${commentId}/replies/${replyId}`,
    DELETE_REPLY:(postId:string, commentId:string, replyId:string) => `/api/posts/${postId}/comments/${commentId}/replies/${replyId}`,
    MY_POSTS: `/api/posts/my`,
    TOGGLE_LIKE:(postId:string) => `/api/posts/${postId}/like`,
    TOGGLE_COMMENT_LIKE:(postId:string, commentId:string) => `/api/posts/${postId}/comments/${commentId}/like`,
    TOGGLE_REPLY_LIKE:(postId:string, commentId:string, replyId:string) => `/api/posts/${postId}/comments/${commentId}/replies/${replyId}/like`,
  },

  NOTICE: {
    VIEW_NOTICE:(noticeId:string) => `/api/notices/${noticeId}`,
    GET_NOTICE:(noticeId:string) => `/api/notices/${noticeId}`,
    INCREASE_VIEW:(noticeId:string) => `/api/notices/${noticeId}/view`,
  },

  ANNOUNCEMENT: {
    TOP: '/api/announcement/top',
  },

  RECRUITMENTS:{
    APPLY:(recruitmentId:number) => `/api/recruitments/${recruitmentId}/apply`,
    APPLICATIONS:(recruitmentId:number) => `/api/recruitments/${recruitmentId}/applications`,
    CLINIC_REGISTER: `/api/recruitments`,
    RECOMMEND:(limit:number, offset:number) => `/api/recruitments/recommend?limit=${limit}&offset=${offset}`,
    REGION :() => `/api/recruitments/region`,
    /** 비슷한 공고 목록 조건(지원 내역 카드) */
    SIMILAR_QUERY:(recruitmentId:number) => `/api/recruitments/${recruitmentId}/similar-query`,
  },

  LIST:{
    TABLE:(fetchUrl:string, listCount:number, offset:number) => {
      const separator = fetchUrl.includes('?') ? '&' : '?';
      return `/api${fetchUrl}${separator}limit=${listCount}&offset=${offset}`;
    },
    APPLY:(limit:number, offset:number) => `/api/applications?limit=${limit}&offset=${offset}`
  },

  APPLICATIONS:{
    /** 지원자 본인의 지원 취소(치과 확인 전) */
    CANCEL:(applicationId:number) => `/api/applications/${applicationId}/cancel`,
  },

  CLINICS:{
	  INFO:(id:number) => `/api/clinics/${id}`,
  },

  RESUME:{
    REGISTER:`/api/resume`,
    UPDATE:`/api/resume`,
    GET:`/api/resume`,
    GET_BY_ID:(resumeId:string) => `/api/resume/${resumeId}`,
    GET_BY_APPLICATION:(applicationId:string) => `/api/applications/${applicationId}/resume`,
  },

  SEMINAR: {
    CREATE: `/api/seminars`,
    GET_LIST: `/api/seminars`,
    GET_DETAIL: (seminarId: string) => `/api/seminars/${seminarId}`,
    UPDATE: (seminarId: string) => `/api/seminars/${seminarId}`,
    DELETE: (seminarId: string) => `/api/seminars/${seminarId}`,
    APPLY: (seminarId: string) => `/api/seminars/${seminarId}/apply`,
    CANCEL: (seminarId: string) => `/api/seminars/${seminarId}/apply`,
    APPLIED: `/api/seminars/applied`,
    MY_REGISTERED: `/api/seminars/my`,
    PAYMENT_HISTORY: `/api/payments/me`,
    BY_USER: (userNo: string) => `/api/seminars/user/${userNo}`,
    REVIEWS: (seminarId: string) => `/api/seminars/${seminarId}/reviews`,
    REVIEW_DETAIL: (seminarId: string, reviewId: string) => `/api/seminars/${seminarId}/reviews/${reviewId}`,
    REVIEW_REPLIES: (seminarId: string, reviewId: string) => `/api/seminars/${seminarId}/reviews/${reviewId}/replies`,
    REVIEW_REPLY_DETAIL: (seminarId: string, reviewId: string, replyId: string) =>
      `/api/seminars/${seminarId}/reviews/${reviewId}/replies/${replyId}`,
    PARTICIPANTS: (seminarId: string) => `/api/seminars/${seminarId}/participants`,
    APPROVE_PARTICIPANT: (seminarId: string, participantNo: string) =>
      `/api/seminars/${seminarId}/participants/${participantNo}/approve`,
    REJECT_PARTICIPANT: (seminarId: string, participantNo: string) =>
      `/api/seminars/${seminarId}/participants/${participantNo}/reject`,
    MARK_ATTENDED: (seminarId: string, participantNo: string) =>
      `/api/seminars/${seminarId}/participants/${participantNo}/attended`,
    CLOSE: (seminarId: string) => `/api/seminars/${seminarId}/close`,
    REOPEN: (seminarId: string) => `/api/seminars/${seminarId}/reopen`,
    RESUME_VISIBILITY: (seminarId: string) => `/api/seminars/${seminarId}/resume-visibility`,
  },

  INSTRUCTOR: {
    APPLY: `/api/seminar/instructor/apply`,
    ME: `/api/seminar/instructor/me`,
    UPDATE_ME: `/api/seminar/instructor/me`,
    MY_APPLICATIONS: `/api/seminar/instructor/my-applications`,
    GET_APPLICATION: (id: string) => `/api/seminar/instructor/${id}`,
  },

  UPLOAD: {
    IMAGE: `/api/upload/image`,
    FILE: `/api/upload/file`,
  },

  INQUIRY: {
    CATEGORIES: `/api/inquiries/categories`,
    CREATE: `/api/inquiries`,
    MY: `/api/inquiries/my`,
    DETAIL: (id: string) => `/api/inquiries/${id}`,
    MESSAGES: (id: string) => `/api/inquiries/${id}/messages`,
    CLOSE: (id: string) => `/api/inquiries/${id}/close`,
  },

  // 이벤트 경품 받기(당첨자 본인) — docs/event-prize-plan.md 2장
  PRIZE: {
    ME: `/api/prizes/me`,
    SUBMIT: (id: string) => `/api/prizes/${encodeURIComponent(id)}/submit`,
    DEPOSITOR: (id: string) => `/api/prizes/${encodeURIComponent(id)}/depositor`,
    FORFEIT: (id: string) => `/api/prizes/${encodeURIComponent(id)}/forfeit`,
    RECEIVED: (id: string) => `/api/prizes/${encodeURIComponent(id)}/received`,
  },

  CATEGORY: {
    LIST: '/api/categories',
  },

  MODERATION: {
    REPORT: `/api/reports`,
    // 콘텐츠 작성자 차단 — 대상 id 만 보내고 작성자는 서버가 찾는다(화면은 다른 회원 번호를 받지 않는다)
    BLOCK_BY_TARGET: `/api/blocks`,
    // 차단 해제 — 차단 목록의 id 로
    UNBLOCK_BY_ID: (blockId: string) => `/api/users/me/blocks/${encodeURIComponent(blockId)}`,
    MY_BLOCKS: `/api/users/me/blocks`,
  },

  EXPERT_CONTENT: {
    META: '/api/expert-contents/meta',
    WRITE_PERMISSION: '/api/expert-contents/write-permission',
    LIST: '/api/expert-contents',
    HOT: '/api/expert-contents/hot',
    MY: '/api/expert-contents/my',
    AUTHORED_BY: (userNo: string) => `/api/expert-contents/authored-by/${userNo}`,
    DETAIL: (id: string) => `/api/expert-contents/${id}`,
    FULL_COMMENTS: (id: string) => `/api/expert-contents/${id}/comments`,
    CREATE: '/api/expert-contents',
    UPDATE: (id: string) => `/api/expert-contents/${id}`,
    DELETE: (id: string) => `/api/expert-contents/${id}`,
    ADD_COMMENT: (id: string) => `/api/expert-contents/${id}/comments`,
    UPDATE_COMMENT: (id: string, commentId: string) => `/api/expert-contents/${id}/comments/${commentId}`,
    DELETE_COMMENT: (id: string, commentId: string) => `/api/expert-contents/${id}/comments/${commentId}`,
    ADD_REPLY: (id: string, commentId: string) => `/api/expert-contents/${id}/comments/${commentId}/replies`,
    UPDATE_REPLY: (id: string, commentId: string, replyId: string) =>
      `/api/expert-contents/${id}/comments/${commentId}/replies/${replyId}`,
    DELETE_REPLY: (id: string, commentId: string, replyId: string) =>
      `/api/expert-contents/${id}/comments/${commentId}/replies/${replyId}`,
    INCREMENT_VIEW: (id: string) => `/api/expert-contents/${id}/view`,
    INCREMENT_DOWNLOAD: (id: string) => `/api/expert-contents/${id}/download`,
    TOGGLE_LIKE: (id: string) => `/api/expert-contents/${id}/like`,
    TOGGLE_COMMENT_LIKE: (id: string, commentId: string) => `/api/expert-contents/${id}/comments/${commentId}/like`,
    TOGGLE_REPLY_LIKE: (id: string, commentId: string, replyId: string) =>
      `/api/expert-contents/${id}/comments/${commentId}/replies/${replyId}/like`,
  },

  SALARY_SURVEY: {
    CURRENT: '/api/salary-surveys/campaigns/current',
    // 회차 키 자리에는 `current`(응답 저장·조회)·`latest`(내 결과·공개 리포트) 별칭을 쓸 수 있다.
    MY_RESPONSE: (key: string) => `/api/salary-surveys/campaigns/${encodeURIComponent(key)}/responses/me`,
    MY_RESULT: (key: string) => `/api/salary-surveys/campaigns/${encodeURIComponent(key)}/results/me`,
    MY_BASELINE: (year: string) => `/api/salary-surveys/baselines/${encodeURIComponent(year)}/comparisons/me`,
    REPORT: (key: string) => `/api/salary-surveys/reports/${encodeURIComponent(key)}`,
    // 리포트 본 처리(로그인) — 마이페이지 새 리포트 N 을 끈다
    REPORT_VIEW: (key: string) => `/api/salary-surveys/reports/${encodeURIComponent(key)}/views/me`,
  },

  // 채용 공고 등록 후 1분 설문 + 홈 추천 24시간 (docs/recruitment-survey-boost-plan.md) — 치과 회원 전용
  RECRUITMENT_SURVEY: {
    PROMPT: (recruitmentId: number) => `/api/recruitments/${recruitmentId}/survey-prompt`,
    SUBMIT: '/api/recruitment-surveys',
    DISMISSAL: '/api/recruitment-surveys/dismissal',
  },

  // AI 질문·답변 (docs/ai-chat/impl-1a.md 1장)
  AI_CHAT: {
    STATUS: '/api/ai-chats/status',
    ACCESS: '/api/ai-chats/access',
    CONSENT: '/api/ai-chats/consent',
    SUGGESTIONS: '/api/ai-chats/suggestions',
    HOOKS: '/api/ai-chats/hooks',
    ROOT: '/api/ai-chats',
    DETAIL: (id: string) => `/api/ai-chats/${encodeURIComponent(id)}`,
    // 답변은 SSE 로 흘러나온다 — axios 가 아니라 aiChatStream.ts(fetch)에서 쓴다
    MESSAGES: (id: string) => `/api/ai-chats/${encodeURIComponent(id)}/messages`,
    FEEDBACK: (id: string, messageId: string) =>
      `/api/ai-chats/${encodeURIComponent(id)}/messages/${encodeURIComponent(messageId)}/feedback`,
    LOUNGE_DRAFT: (id: string) => `/api/ai-chats/${encodeURIComponent(id)}/lounge-draft`,
    COMMUNITY_DRAFT: (id: string) => `/api/ai-chats/${encodeURIComponent(id)}/community-draft`,
    LOUNGE_LINK: (id: string) => `/api/ai-chats/${encodeURIComponent(id)}/lounge-link`,
    // 공고 글 옮기기 — [이대로 공고 등록하기] 초안 만들기(치과 계정)·등록 화면이 읽기(docs/ai-chat/prompt-engine-plan.md 7장)
    RECRUITMENT_DRAFT: (id: string, messageId: string) =>
      `/api/ai-chats/${encodeURIComponent(id)}/messages/${encodeURIComponent(messageId)}/recruitment-draft`,
    RECRUITMENT_DRAFT_DETAIL: (draftId: string) => `/api/ai-recruitment-drafts/${encodeURIComponent(draftId)}`,
    // [이 내용으로 문의하기] — 답의 문의 초안(세미나 참조면 서버가 본인 주문번호를 채운다)
    INQUIRY_DRAFT: (id: string, messageId: string) =>
      `/api/ai-chats/${encodeURIComponent(id)}/messages/${encodeURIComponent(messageId)}/inquiry-draft`,
    // 대화로 공고 등록하기 — 지금 값(상세 미리보기)·[공고 등록하기]·[등록 화면에서 직접 고치기]
    // 원장 공간 답 끝 객관식 질문에 답하기
    OWNER_ASK_ANSWER: (askId: string) => `/api/ai-owner-asks/${encodeURIComponent(askId)}/answer`,
    RECRUITMENT_FLOW: (flowId: string) => `/api/ai-recruitment-flows/${encodeURIComponent(flowId)}`,
    RECRUITMENT_FLOW_DETAIL_PREVIEW: (flowId: string) => `/api/ai-recruitment-flows/${encodeURIComponent(flowId)}/detail-preview`,
    RECRUITMENT_FLOW_PUBLISH: (flowId: string) => `/api/ai-recruitment-flows/${encodeURIComponent(flowId)}/publish`,
    RECRUITMENT_FLOW_FILL: (flowId: string) => `/api/ai-recruitment-flows/${encodeURIComponent(flowId)}/fill`,
    RECRUITMENT_FLOW_EDITOR: (flowId: string) => `/api/ai-recruitment-flows/${encodeURIComponent(flowId)}/editor-draft`,
    REPOST: (chatId: string) => `/api/ai-chats/${encodeURIComponent(chatId)}/repost`,
    // 대화 공유 — 공유 전 개인정보 검사·공유 만들기(PUT)·공유 중지(DELETE)
    SHARE_CHECK: (id: string) => `/api/ai-chats/${encodeURIComponent(id)}/share/check`,
    SHARE: (id: string) => `/api/ai-chats/${encodeURIComponent(id)}/share`,
    // 공유받은 대화 — 보기·신고는 비로그인도 된다. 이어서 질문하기(SSE)는 aiChatStream.ts 에서 쓴다
    SHARED: (token: string) => `/api/ai-shares/${encodeURIComponent(token)}`,
    SHARED_MESSAGES: (token: string) => `/api/ai-shares/${encodeURIComponent(token)}/messages`,
    SHARED_REPORTS: (token: string) => `/api/ai-shares/${encodeURIComponent(token)}/reports`,
  },
};
